import { Modal } from "../Modal"

const READ_ONLY_NOTICE_DESCRIPTION = "編集・保存はできません。"

type ReadOnlyNoticeModalProps = {
  isOpen: boolean
  onClose: () => void
  message: string
}

export function ReadOnlyNoticeModal({ isOpen, onClose, message }: ReadOnlyNoticeModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="flex flex-col items-center justify-center w-[520px] h-[220px] px-[25px]"
    >
      <span className="text-black text-center">
        <p>{message}</p>
        <p>{READ_ONLY_NOTICE_DESCRIPTION}</p>
      </span>
      <button
        className="mt-[18px] w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-bold"
        onClick={onClose}
      >
        閉じる
      </button>
    </Modal>
  )
}
